module.exports = __webpack_public_path__ + "static/media/PALOSANTO_03.e3afe02a.png";